
import { useI18n } from "src/utils/lni18n";
import { useAtom } from "jotai";
import courseService, { currentCourseAtom, oneCourseatom } from "../CourseService";
import { useEffect, useMemo, useState } from "react";
import LnIcon from "src/components/LnIcon";
import DirtyPartsTree from "./DirtyPartsTree";
import WaitRipple from "src/components/WaitRipple";
import { useConfirm } from "src/components/Modalservice/UseConfirm";
import { AffectedClassesList } from "./AffectedClassesList";


const CoursePublish = () => {

    const [courseId] = useAtom(currentCourseAtom);
    const courseAtom = useMemo(() => oneCourseatom(courseId || ""), [courseId]);
    const [course] = useAtom(courseAtom);
    const confirm = useConfirm();
    const { languageService: t } = useI18n();
    const [courseDirty, setCourseDirty] = useState(false);

    useEffect(() => {
        if (course && courseId) {
            setCourseDirty(courseService.arePartsInCourseDirty(courseId));
        }
    }, [course, courseId]);

    if (course === undefined || course === null) {
        return <WaitRipple />;
    }

    const readOnly = !!course.Locked;

    function publishCourse(): void {

        confirm("md", t.getText("publish"),
            <div className="preserve-white" >{t.getText("publish.course.sure")}</div>)
            .then(async (res: boolean) => {
                if (res) {
                    await courseService.publish(courseId!);
                }
            }).catch((error) => {
                console.error("Publish failed:", error);
            });


    }
    return (
        <div className="mb-5">

            <div className="d-flex mb-3">

                <h3 className="mb-4">{t.getText("publish")}</h3>
                <div className="ms-auto d-flex align-items-center">
                    {course.IsDirty && <LnIcon name="alert" className='me-3' />}
                    <button disabled={!course.IsDirty} onClick={publishCourse} className="ms-auto  mb-3 btn btn-primary">{t.getText("publish")}</button>
                </div>

            </div>
            <div className='d-flex mb-3'>
                <div className='ms-auto pe-4'>
                    {course.IsDirty && <span >{t.getText("course.not.published")}</span>}
                    {!course.IsDirty && <span >{t.getText("published")}</span>}
                </div>
            </div>



            <div>
                <h4>{t.getText("classes")}</h4>
                <div className="preserve-white my-3">
                    {t.getText("savecourse2server.current.courses")}
                </div>
                <div className="my-4">
                    <AffectedClassesList classes={course.Course.StudentClasses} />
                </div>
            </div>

            {!readOnly &&
                <div>
                    {courseDirty &&

                        <div className="row my-5">
                            <div className="col-sm d-flex align-items-start mb-3">
                                <LnIcon name="alert" className="me-3" />
                                <div className="preserve-white">{t.getText("course.parts.dirty.explain")}</div>
                            </div>

                            <div className="col-sm ">
                                <DirtyPartsTree course={course.Course} />
                            </div>
                        </div>



                    }

                </div>
            }
        </div >

    )
}

export default CoursePublish;
